import { Flex, FlexAnchor, Icon, mdBumps, smBumps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { Profile } from '../../../../../../domain'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'

interface ProfileButtonProps {
  profile: Profile
  onClick: (profile: Profile) => void
  referred: boolean
  complete: boolean
  tKey: TKeyBuilder
}

export const ProfileButton: FunctionComponent<ProfileButtonProps> = ({
  profile,
  onClick,
  referred,
  complete,
  tKey,
}) => {
  const { t } = useWriskTranslation()

  const onUpdate = useCallback(() => onClick(profile), [onClick, profile])

  const rightIcon = referred ? 'warning' : complete ? 'tick' : 'chevronRight'

  return (
    <FlexAnchor
      className='policy-holder-button'
      width={1}
      variant='inset'
      px={mdBumps}
      py={3}
      onClick={onUpdate}
    >
      <Flex flexDirection='row' alignItems='center'>
        <Icon icon='account' mr={smBumps} />
        <Typo>{t(tKey('actions.update'), { profile })}</Typo>
      </Flex>
      <Icon icon={rightIcon} size='tiny' />
    </FlexAnchor>
  )
}
